import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import {FeatureGatePageWrapper} from '../../limits/feature-gates/feature-gate-page-wrapper';

export function ManagedMeetingsFeatureGatePage() {
    return (
        <div className='background-offwhite'>
            <FeatureGatePageWrapper
                header='Upgrade your plan to Business or Enterprise to start now'
                subHeader='Create managed meetings for your team so they can focus on bookings instead'
                bullets={[
                    'Configure meetings so that new users automatically have Scheduler meetings ready-to-go',
                    'Ensure all meetings maintain consistency that align with your company’s standards',
                ]}
                feature='schedulerFull'
                icon={<Illustration src='managed-meetings' />}
                noClosingMessage={true}
                buttonText='Upgrade plan'
            />
        </div>
    );
}
